import React, { Component } from 'react';
import Chart from "react-apexcharts";
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { connect } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components

class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar"
        },
        xaxis: {
          categories: ["Luxembourg", "Belgique", "France"]
        },
        series: [{
          name: 'sales',
          data: [30,40,35,50,49,60,70,91,125]
        }],
        colors:['#2e3192', '#0db810', '#cfbf39'],
        dataLabels: {
          style: {
            colors: ['#eee', '#eee', '#eee']
          }
        },
      },
      series: [{
        name: 'sales',
        data: [457.50,1157.50,212.80]
      }],
      seriesPie: [44, 55, 41, 17, 15],
      
      numReq1:23,
      numReq2:23,
      numReq3:23,
      numReq4:24,
      
    };
  }


  render() {
    var colorPie = ['#00188f','#009e49','#68217a','#bad80a','#00b294','#e81123','#00bcf2','#fff100','#ec008c', '#ff8c00'];
    var seriesBar1 = [];
    var options= {};
    var seriebar2 = [];
    var options2 ={};
    var seriebar3 = [];
    var options3 ={};
    var pieOption0= {};
    var pieOption1= {};
    var pieSerie0 = [];
    var pieSerie1 = [];
    var pieOption2= {};
    var pieSerie2 = [];
    
    
    // PIE 0
    try{
      pieOption0= { 
        colors: colorPie,
        labels: this.props.formatedData.length>0? this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[1].labels : [],
      };
      pieSerie0 = this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[1].data:[];
    }catch(err) {
      console.log("error",err);
    }
    // PIE 1
    try{
      pieOption1= { 
        colors: colorPie,
        labels: this.props.formatedData.length>0? this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[2].labels : [],
      };
      pieSerie1 = this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[2].data:[];
    }catch(err) {
      console.log("error",err);
    }
    // PIE 2
    try{
      
      pieOption2= { 
        colors: colorPie,
        labels: this.props.formatedData.length>0? this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[3].labels : [],
        pie: {
          donut: {
            size: '65%'
          }
        }
      };
      pieSerie2 = this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[3].data:[];
    }catch(err) {
      console.log("error",err);
    }

    // BAR 1
    try {
      seriesBar1 = [{
        name: this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[0].category:"",
        data: this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[0].data:[],
      }];

      options = {
        chart: {
          id: "basic-bar"
        },
        xaxis: {
          type: 'category'
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top',
              
            },
          }
        },
        colors:colorPie[4],
        dataLabels: {
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#666666"]
          }
        }
      };

      
    }
    catch(err) {
      console.log("error",err);
    }

    // BAR 2
    try{
      options2 ={
        chart: {
          id: "bar",
          stacked: true,
          stackType: '100%'
        },
        xaxis: {
          categories: ['Exercice en cours',"Exercice antérieur"
          ],
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'center',
            },
          }
        },
        colors:colorPie,
        dataLabels: {
          style: {
            fontSize: '12px',
            colors: ["#ffffff"]
          }
        }
      };

      if(this.props.formatedData.length>0){
        var dataTmp = this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].requetes.filter(item=>item.number ===23)[0];
        
        var modifier = 0;
        dataTmp.data.forEach((element,i) => {
          if(element[1].value === "60" || element[1].value === "70"){
            var graphColumn = {};
            var val1 = Math.abs(Number.parseFloat(element[2].value).toFixed(2)); 
            var exist = this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].requetes.filter(item=>item.number ===24)[0].data.filter(item=>item[1].value===element[1].value).length>0;
            modifier = exist? modifier:modifier-1;
            var val2 = exist?
              Math.abs(
                Number.parseFloat(
                  this.props.formatedData.filter(
                    item=>item.dbLink === this.props.clientActive
                    )[0].requetes.filter(
                      item=>item.number ===24
                      )[0].data.filter(
                        item=>item[1].value===element[1].value
                        )[0][2].value.toFixed(2))) 
            : 0;
            
            graphColumn = {name:element[1].value, data:[val1,val2]};
            seriebar2.push(graphColumn);
          }
          
        });
      }
    }
    catch(err){
      console.log("error",err);
    }

    // BAR 3
    try{


      options3 ={
        chart: {
          id: "area",
        },
        xaxis: {
          categories: this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[5].xaxis:[],
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top',
            },
          }
        },
        colors:colorPie,
        dataLabels: {
          enabled: false
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.8,
            opacityFrom: 0.4,
            opacityTo: 0.8,
            stops: [0, 90, 100]
          }
        },
      };
      seriebar3 = this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[5].data:[];
      console.log('seriesbar3', seriebar3);
    }
    catch(err){
      console.log("error",err);
    }

    return (
      <div className="Homepage View">
        
        <div className="View-content">
          <div className="View-header">
            <h1 className="View-title">Dashboard</h1>
          </div>
            <div className="chart-container">
              <div className="chart">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[0].name : "" }</div>
                <Chart
                    options={options}
                    series={seriesBar1}
                    type="bar"
                    width="500"
                    height="400"
                />
              </div>
              <div className="chart">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[4].name : "" }</div>
                <Chart
                    options={options2}
                    series={seriebar2}
                    type="bar"
                    width="500"
                    height="400"
                />
              </div>
              <div className="chart">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[1].name : "" }</div>
                <Chart
                    options={pieOption0}
                    series={pieSerie0}
                    type="pie"
                    width="500"
                />
              </div>
              <div className="chart">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[2].name : "" }</div>
                <Chart
                    options={pieOption1}
                    series={pieSerie1}
                    type="pie"
                    width="500"
                />
              </div>
              <div className="chart">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[3].name : "" }</div>
                <Chart
                    options={pieOption2}
                    series={pieSerie2}
                    type="donut"
                    width="500"
                />
              </div>
              <div className="chart wide">
                <div className="chart-name">{this.props.formatedData.length>0?this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].dashboard[5].name : "" }</div>
                <Chart
                    options={options3}
                    series={seriebar3}
                    type="area"
                    height="400"
                />
              </div>
          </div>
        </div>
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {    
  return {  
    formatedData:state.apiReducer.formatedData,
    clientActive:state.apiReducer.clientActive,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    formatData: (data) => dispatch(repositoryActions.formatData(data)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);